import commonUtil from '../../utils/commonUtil';

export const EVENTDETAILS_LOAD = 'EVENTDETAILS_LOAD';
export const EVENTDETAILS_LOAD_SUCCESS = 'EVENTDETAILS_LOAD_SUCCESS';
export const EVENTDETAILS_LOAD_FAIL = 'EVENTDETAILS_LOAD_FAIL';
export const EVENTTOKEN_LOAD = 'EVENTTOKEN_LOAD';
export const EVENTTOKEN_LOAD_SUCCESS = 'EVENTTOKEN_LOAD_SUCCESS';
export const EVENTTOKEN_LOAD_FAIL = 'EVENTTOKEN_LOAD_FAIL';

export function isEventDetailsLoaded(globalState) {
  return globalState.eventDetails && globalState.eventDetails.loaded;
}
export function loadEventDetails(profileId, emailId) {
  const _eventDetailsInput = {};
  _eventDetailsInput.brand = commonUtil.getBrand();
  _eventDetailsInput.channel = commonUtil.getChannel();
  // _eventDetailsInput.profileId = profileId;
  // _eventDetailsInput.emailId = emailId;

  return {
    types: [
      EVENTDETAILS_LOAD,
      EVENTDETAILS_LOAD_SUCCESS,
      EVENTDETAILS_LOAD_FAIL,
    ],
    promise: (client) =>
      client.post('/api/getProfileEventDetails', {
        data: _eventDetailsInput,
      }),
  };
}
export function getEventToken(eventId) {
  const _eventTokenInput = {};
  _eventTokenInput.eventId = eventId;

  return {
    types: [EVENTTOKEN_LOAD, EVENTTOKEN_LOAD_SUCCESS, EVENTTOKEN_LOAD_FAIL],
    promise: (client) =>
      client.post('/api/generateTokenIdForOwner', {
        data: _eventTokenInput,
      }),
  };
}
